import React from "react";

const About = () => {
  return (
      <div className='page-content'>
          <div className='page-banner-content mb-5'>
              <div className='container'>
                  <div className='section-title-div wow animate__animated animate__fadeInDown'>
                      <h1>
                          Application
                          <span className='text-primary'> Transformation & Modernization</span>
                      </h1>
                      <p>
                          Empowering you to optimize your distributed infrastructure, enhance visibility, maintain security, and reduce complexity.
                      </p>
                  </div>
              </div>

          </div>

          <div className='page-banner mb-5'>
              <div className='container'>
                  <div className='page-img wow animate__animated animate__zoomIn'>
                      <img
                          src="/assets/images/application-img.png"
                          alt="img"
                          className="img-fluid w-100"
                      />
                  </div>
              </div>
          </div>

          <div className='service-feature'>
              <div className='container'>
                  <div className='col-md-12'>
                      <div className='row'>
                          <div className='col-md-6 mb-5'>
                              <div className='sf-card h-100 sf-round1 wow animate__animated animate__zoomIn'>
                                  <h4>Application-wide Dev-to-Dev Sync and Assessment</h4>
                                  <p>
                                      Sem integer vitae justo eget magna fermentum iaculis. Feugiat scelerisque varius
                                      morbi
                                      enim nunc faucibus.
                                  </p>
                              </div>
                          </div>

                          <div className='col-md-6 mb-5'>
                              <div className='sf-card h-100 sf-round2 wow animate__animated animate__zoomIn'>
                                  <h4>Selection of off-the-self application, uplift or recode</h4>
                                  <p>
                                      Sem integer vitae justo eget magna fermentum iaculis. Feugiat scelerisque varius
                                      morbi enim nunc faucibus.
                                  </p>
                              </div>
                          </div>

                          <div className='col-md-6 mb-5'>
                              <div className='sf-card h-100 sf-round3 wow animate__animated animate__zoomIn'>
                                  <h4>Co-development in
                                      SAFe 6.0</h4>
                                  <p>
                                      Sem integer vitae justo eget magna fermentum iaculis. Feugiat scelerisque varius
                                      morbi enim nunc faucibus.
                                  </p>
                              </div>
                          </div>

                          <div className='col-md-6 mb-5'>
                              <div className='sf-card h-100 sf-round4 wow animate__animated animate__zoomIn'>
                                  <h4>Production GTM Strategy
                                      for each App</h4>
                                  <p>
                                      Sem integer vitae justo eget magna fermentum iaculis. Feugiat scelerisque varius
                                      morbi enim nunc faucibus.
                                  </p>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

          </div>


          <div className='customer-approach-section'>
              <div className='container'>
                  <div className='row'>
                      <div className='col-md-12'>
                          <div className='section-title-div wow animate__animated animate__fadeInDown'>
                              <h1>
                                  Customer Centric
                                  <span className='text-primary'>Approach</span>
                              </h1>
                          </div>
                          <div className='row row-gap-3'>
                              <div className='col-md-7 order-2 order-sm-2 order-md-1'>
                                  <div className='cas-collapes  wow animate__animated animate__fadeInLeft'>
                                      <div className="accordion" id="accordionExample">
                                          <div className="accordion-item">
                                              <h2 className="accordion-header" id="heading1">
                                                  <button className="accordion-button" type="button"
                                                          data-bs-toggle="collapse"
                                                          data-bs-target="#collapse1" aria-expanded="true"
                                                          aria-controls="collapse1">
                                                      24/7 Support
                                                  </button>
                                              </h2>
                                              <div id="collapse1" className="accordion-collapse collapse show"
                                                   aria-labelledby="heading1" data-bs-parent="#accordionExample">
                                                  <div className="accordion-body">
                                                      Dedicated to helping customers achieve their goals and maximize
                                                      the
                                                      value
                                                      of their technology investments, with a strong focus on customer
                                                      satisfaction.
                                                  </div>
                                              </div>
                                          </div>
                                          <div className="accordion-item">
                                              <h2 className="accordion-header" id="heading2">
                                                  <button className="accordion-button collapsed" type="button"
                                                          data-bs-toggle="collapse" data-bs-target="#collapse2"
                                                          aria-expanded="false" aria-controls="collapse2">
                                                      Commitment to Customer Success
                                                  </button>
                                              </h2>
                                              <div id="collapse2" className="accordion-collapse collapse"
                                                   aria-labelledby="heading2" data-bs-parent="#accordionExample">
                                                  <div className="accordion-body">
                                                      Dedicated to helping customers achieve their goals and maximize
                                                      the
                                                      value
                                                      of their technology investments, with a strong focus on customer
                                                      satisfaction.
                                                  </div>
                                              </div>
                                          </div>
                                          <div className="accordion-item">
                                              <h2 className="accordion-header" id="heading3">
                                                  <button className="accordion-button collapsed" type="button"
                                                          data-bs-toggle="collapse" data-bs-target="#collapse3"
                                                          aria-expanded="false" aria-controls="collapse3">
                                                      Security-Focused
                                                  </button>
                                              </h2>
                                              <div id="collapse3" className="accordion-collapse collapse"
                                                   aria-labelledby="heading3" data-bs-parent="#accordionExample">
                                                  <div className="accordion-body">
                                                      Dedicated to helping customers achieve their goals and maximize
                                                      the
                                                      value
                                                      of their technology investments, with a strong focus on customer
                                                      satisfaction.
                                                  </div>
                                              </div>
                                          </div>
                                          <div className="accordion-item">
                                              <h2 className="accordion-header" id="heading4">
                                                  <button className="accordion-button collapsed" type="button"
                                                          data-bs-toggle="collapse" data-bs-target="#collapse4"
                                                          aria-expanded="false" aria-controls="collapse4">
                                                      Extensive Knowledge Base
                                                  </button>
                                              </h2>
                                              <div id="collapse4" className="accordion-collapse collapse"
                                                   aria-labelledby="heading4" data-bs-parent="#accordionExample">
                                                  <div className="accordion-body">
                                                      Dedicated to helping customers achieve their goals and maximize
                                                      the
                                                      value
                                                      of their technology investments, with a strong focus on customer
                                                      satisfaction.
                                                  </div>
                                              </div>
                                          </div>
                                          <div className="accordion-item">
                                              <h2 className="accordion-header" id="heading5">
                                                  <button className="accordion-button collapsed" type="button"
                                                          data-bs-toggle="collapse" data-bs-target="#collapse5"
                                                          aria-expanded="false" aria-controls="collapse5">
                                                      Flexible Deployment Options
                                                  </button>
                                              </h2>
                                              <div id="collapse5" className="accordion-collapse collapse"
                                                   aria-labelledby="heading5" data-bs-parent="#accordionExample">
                                                  <div className="accordion-body">
                                                      Dedicated to helping customers achieve their goals and maximize
                                                      the
                                                      value
                                                      of their technology investments, with a strong focus on customer
                                                      satisfaction.
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div className='col-md-5 order-1 order-sm-1 order-md-2'>
                                  <div className='cas-img  wow animate__animated animate__fadeInRight'>
                                      <img
                                          src="/assets/images/approach-img.png"
                                          alt="img"
                                          className="img-fluid w-100"
                                      />
                                  </div>
                              </div>
                          </div>
                      </div>

                  </div>
              </div>
          </div>

      </div>
  );
};

export default About;
